import { render, staticRenderFns } from "./ZoneUpdate.vue?vue&type=template&id=524bd12c&"
import script from "./ZoneUpdate.vue?vue&type=script&lang=ts&"
export * from "./ZoneUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports